import { promisifyDialog } from '@shared/utils/dialog'
import Modal from './index.vue'
import Rename from './Rename.vue'
import DeleteModal from './Delete.vue'
import UpdateModal from '@remote/components/business/version/modal.vue'
import HeziScrapePathSetting from '@remote/views/scrape-settings/SourceSettingsCinemaModal.vue'
import HeziMultiPathSelector from '@remote/components/business/multi-path-selector/modal.vue'
import HeziAlbumPathSetting from '@remote/views/scrape-settings/SourceSettingsAlbumModal.vue'
import type { IUpdateModalRef } from '@remote/components/business/version/type.d'

const show = (props: PromisifyDialogProps<typeof Modal>) => {
  return promisifyDialog(Modal, props)
}

const rename = (props: PromisifyDialogProps<typeof Rename>) => {
  return promisifyDialog(Rename, props)
}

const showScrapePathSettingModal = (props: PromisifyDialogProps<typeof HeziScrapePathSetting>) => {
  return promisifyDialog(HeziScrapePathSetting, props)
}

const showAlbumPathSettingModal = (props: PromisifyDialogProps<typeof HeziAlbumPathSetting>) => {
  return promisifyDialog(HeziAlbumPathSetting, props)
}

const showVersionUpdateModal = (props: PromisifyDialogProps<typeof UpdateModal>) => {
  let ref: IUpdateModalRef | undefined = undefined
  const getRef = (modalRef: IUpdateModalRef) => {
    ref = modalRef
    props.getRef?.(modalRef)
  }

  promisifyDialog(UpdateModal, Object.assign({}, props, { getRef }))

  return () => {
    ref?.close()
  }
}

const Delete = (props: PromisifyDialogProps<typeof DeleteModal>) => {
  return promisifyDialog(DeleteModal, props)
}

const showHeziMulPathSelector = (props: PromisifyDialogProps<typeof HeziMultiPathSelector>) => {
  return promisifyDialog(HeziMultiPathSelector, props)
}

export default {
  show,
  rename,
  showVersionUpdateModal,
  Delete,
  showHeziMulPathSelector,
  showScrapePathSettingModal,
  showAlbumPathSettingModal,
}